import { useState } from 'react';

import { buildMessagesCreateUrl } from '@/modules/messages/helpers';
import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductTracking } from '@/modules/product/hooks/useProductTracking';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Options = {
  messageInteractionType?: string;
};

export function useSellerActions({
  messageInteractionType = 'AskAQuestionClick',
}: Options = {}) {
  const { isSuccess, data: productBasic } = useProductBySlugBasicPDP();
  const [isAuthenticated] = useCurrentUser();
  const { sendProductInteractionActionATEvent } = useProductTracking();
  const [isDownloadAppModalOpen, setIsDownloadAppModalOpen] = useState(false);

  const seller = productBasic?.seller;
  const productId = productBasic?.id;
  const brandId = productBasic?.brand_id;

  const shopHref = brandId
    ? `/${seller?.username}/?brandIds=${brandId}&productId=${productId}`
    : `/${seller?.username}`;

  const messagesUrl = buildMessagesCreateUrl({
    recipientId: seller?.id,
    productId,
  });

  function handleVisitShopClick() {
    sendProductInteractionActionATEvent(productId, 'VisitShopClick');
  }

  function handleMessageClick() {
    sendProductInteractionActionATEvent(productId, messageInteractionType);
    if (!isAuthenticated) {
      sendProductInteractionActionATEvent(productId, 'ProductChat');
      setIsDownloadAppModalOpen(true);
    }
  }

  return {
    isSuccess,
    isAuthenticated,
    seller,
    shopHref,
    messagesUrl,
    handleVisitShopClick,
    handleMessageClick,
    isDownloadAppModalOpen,
    setIsDownloadAppModalOpen,
  };
}
